export const partnerDocumentsViewInitValue = {
  data: {
    certificateValueSharesDocuments: [],
    otherDocuments: [],
    sharesOwnershipDocuments: [],
    partnerId: '',
    partnerName: '',
    partner: null,
    isLoading: false,
    viewAsPartner: false,
    effectiveIsAdmin: false,
    showDemoRoleSwitch: false,
  },
  actions: {
    handleUploadDocument: () => {},
    handleRemoveDocument: async () => {},
    handleChangeDemoView: () => {},
  },
};
